<template>
  <div>
    <button
      v-if="showButton"
      class="button__back-to-top"
      variant="outline-primary"
      size="md"
      @click="scrollToTop"
    >
      <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'arrow-up' }" />
      <span class="ml-2 text__back-to-top"> Back to top </span>
    </button>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faArrowUp);
export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  data() {
    return {
      showButton: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showButton = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped lang="scss">
.button__back-to-top {
  position: fixed;
  bottom: 13px;
  right: 140px;

  background-color: #ffffff;
  border-radius: 50%;
  padding: 10px 16px;
  border: 1px solid #3c44b1;
  color: #3c44b1;
  width: max-content;
  outline: none;

  &:hover {
    background-color: #3c44b1;
    color: #ffffff;
  }
}

.text__back-to-top {
  display: none;
}

@media screen and (max-width: 768px) {
  .button__back-to-top {
    padding: 8px 18px;
    border-radius: 8px;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
  }

  .text__back-to-top {
    display: inline;
  }
}
</style>
